import moment from "moment";

const getDataBetweenDates = (data, startDate, endDate) => data.filter(refData => moment(moment(refData.Date).format('YYYY-MM-DD')).isBetween(startDate, endDate));

const getMonthStartDate = (month, type = "prev") => type === "prev" ? moment().subtract(month, 'months').startOf('month').format('YYYY-MM-DD') : moment().add(month, 'months').startOf('month').format('YYYY-MM-DD');
const getMonthEndDate = (month, type = "prev") => "prev" ? moment().subtract(month, 'months').endOf('month').format('YYYY-MM-DD') : moment().add(month, 'months').endOf('month').format('YYYY-MM-DD');

const getDate = (day) => moment().startOf('week').add(day, 'day').format('DD-MM-YYYY');

const getMonthName = (month) => {
    const monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    return monthName[month]
}

export { getDataBetweenDates, getMonthStartDate, getMonthEndDate, getMonthName, getDate }